module.exports = __webpack_public_path__ + "static/media/trip-advisor-review-2.d40596a2.png";